import { createStructuredSelector } from 'reselect';
import {
    VEHICLE_LIST,
    VEHICLE_LIST_SUCCESS,
    VEHICLE_LIST_ERROR,
    VEHICLE_PAGE_SET,
    VEHICLE_DETAIL,
    VEHICLE_DETAIL_SUCCESS,
    VEHICLE_DETAIL_ERROR,
    VEHICLE_VIEW_MODAL_SET,
    VEHICLE_ADD_MODAL_SET,
    VEHICLE_ADD,
    VEHICLE_ADD_SUCCESS,
    VEHICLE_ADD_ERROR,
    VEHICLE_ADD_CHANGE,
    VEHICLE_EDIT_MODAL_SET,
    VEHICLE_EDIT_SET,
    VEHICLE_EDIT_CHANGE,
    VEHICLE_UPDATE,
    VEHICLE_UPDATE_SUCCESS,
    VEHICLE_UPDATE_ERROR
} from '../actions';

export const VehicleList = (page, num_page) => ({
    type: VEHICLE_LIST,
    payload: { page, num_page }
});

export const VehicleListSuccess = (data) => ({
    type: VEHICLE_LIST_SUCCESS,
    payload: data
});

export const VehicleListError = (error) => ({
    type: VEHICLE_LIST_ERROR,
    payload: error
});

export const VehiclePageSet = (data) => ({
    type: VEHICLE_PAGE_SET,
    payload: data
});

export const VehicleDetail = (data) => ({
    type: VEHICLE_DETAIL,
    payload: data
});

export const VehicleDetailSuccess = (data) => ({
    type: VEHICLE_DETAIL_SUCCESS,
    payload: data
});

export const VehicleDetailError = (error) => ({
    type: VEHICLE_DETAIL_ERROR,
    payload: error
});

export const VehicleViewModalSet = (data) => ({
    type: VEHICLE_VIEW_MODAL_SET,
    payload: data
});

export const VehicleAddModalSet = (data) => ({
    type: VEHICLE_ADD_MODAL_SET,
    payload: data
});

export const VehicleAddAction = (data) => ({
    type: VEHICLE_ADD,
    payload: data
});

export const VehicleAddSuccess = (data) => ({
    type: VEHICLE_ADD_SUCCESS,
    payload: data
});

export const VehicleAddError = (error) => ({
    type: VEHICLE_ADD_ERROR,
    payload: error
});

export const VehicleAddChangeSet = (data) => ({
    type: VEHICLE_ADD_CHANGE,
    payload: data
});

export const VehicleEditModalSet = (data) => ({
    type: VEHICLE_EDIT_MODAL_SET,
    payload: data
});

export const VehicleEditSet = (data) => ({
    type: VEHICLE_EDIT_SET,
    payload: data
});

export const VehicleEditChangeSet = (data) => ({
    type: VEHICLE_EDIT_CHANGE,
    payload: data
});

export const VehicleUpdateAction = (data) => ({
    type: VEHICLE_UPDATE,
    payload: data
});

export const VehicleUpdateSuccess = (data) => ({
    type: VEHICLE_UPDATE_SUCCESS,
    payload: data
});

export const VehicleUpdateError = (error) => ({
    type: VEHICLE_UPDATE_ERROR,
    payload: error
});

const vehicle = (state) => state.vehicle;

export const VehicleSelector = createStructuredSelector({ vehicle });
